export class AdditionalPremiumRatePostData {
    certificateRequestId: number;
    certificateRuleId: string;
    additionalPremiumRate: number;
    remarks?: string;
    requestRuleTableId?: any;
    vesselName?: string;
}